export default "__VITE_ASSET__5d963fba__"